import styled from 'styled-components';

export const Wrapper = styled.div`
  flex-direction: column;
  flex: 1 1 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${({ theme }) => theme.backgrounds.actionBar};
`;
Wrapper.displayName = 'Wrapper';

export const NameWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
NameWrapper.displayName = 'NameWrapper';

export const Name = styled.div`
  color: ${({ theme }) => theme.text.tableVulnName};
  font-size: 14.5px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
Name.displayName = 'Name';

export const Categories = styled.div`
  color: #90a9c0;
  font-size: 14.5px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
Categories.displayName = 'Categories';
